import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  Input,
  Label,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import Flatpickr from "react-flatpickr";
import { Formik } from "formik";
import { data } from "../View Profile/Component/Data";
import PersonalDetail from "./Component/PersonalDetail";
import UpdateTradingHour from "./Component/UpdateTradingHour";
import { validationSchema } from "./Component/ValidationSchema";
import QrModal from "./Component/QrModal";
import OrganizationService from "../../Services/QRCodeServices/OrganizationManagement/OrganizationService";
import toast from "react-hot-toast";
import UpdateTheme from "./Component/UpdateTheme";
import { useParams } from "react-router-dom";
import { ORG_PROFILE_UPDATE } from "../../api/endpoints";

const UpdateProfile = () => {
  const { id } = useParams(); // Destructure 'id' directly from useParams
  console.log("🚀 ~ UpdateProfile ~ id:", id);
  document.title = "Profile Settings | QR Code Menu";

  const user = JSON.parse(localStorage.getItem("user"));

  const orgId = user?.organizationInfo?.id || id; // Null if user or organizationInfo is not available
  console.log("🚀 ~ UpdateProfile ~ orgId:", orgId);

  const [activeTab, setActiveTab] = useState("1");

  const [data, setData] = useState([]);
  const orgCode = user?.organizationInfo?.orgCode || data?.orgCode; // If orgCode exists, use it; otherwise, use id
  console.log("🚀 ~ UpdateProfile ~ orgCode:", orgCode);

  const fetchDetail = async () => {
    try {
      const response = await OrganizationService.detail(orgId);
      console.log("🚀 ~ fetchDetail ~ response:", response);
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDetail();
  }, []);

  const tabChange = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const goToNextTab = () => {
    setActiveTab((prevTab) => (parseInt(prevTab) + 1).toString());
  };

  const goToPreviousTab = () => {
    setActiveTab((prevTab) => (parseInt(prevTab) - 1).toString());
  };

  const initialValues = {
    name: data?.name || "",
    tagLine: data?.tagLine || "",
    address1: data?.address1 || "",
    address2: data?.address2 || "",
   
    disableBotInCutsomer: data?.disableBotInCutsomer || false, 


    contactNo: data?.contactNo || "",
    email: data?.email || "",
    website: data?.website || "",
    logo: data?.logo || "",
    banner: data?.banner || "",
    aboutUs: data?.aboutUs || "",
    vatPercentage: data?.vatPercentage || "",
    serviceChargePercentage: data?.serviceChargePercentage || "",
    themeId: data?.themeId || "",
    orgTradingHour:
      data?.orgTradingHour?.map((hour) => ({
        day_of_week: hour.dayOfWeek || "",
        opening_time: hour.openingTime || "",
        closing_time: hour.closingTime || "",
        bar_timing: hour.barTiming || "",
        id: hour.id || "",
      })) || [],
  };

  console.log("🚀 ~ UpdateProfile ~ initialValues:", initialValues);

  //-----------------Image and banner -------------------------------------
  const [profileImage, setProfileImage] = useState(
    initialValues.logo ? `data:image/jpeg;base64,${initialValues.logo}` : ""
  );
  const [bannerImage, setBannerImage] = useState(
    initialValues.banner ? `data:image/jpeg;base64,${initialValues.banner}` : ""
  ); // Initial banner from server
  const [profileImageFile, setProfileImageFile] = useState(null); // Store profile image file
  const [bannerImageFile, setBannerImageFile] = useState(null); // Store the file to upload
  console.log("🚀 ~ UpdateProfile ~ bannerImageFile:", bannerImageFile);
  // Handle file change for banner image
  const handleBannerImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        setBannerImage(reader.result); // Set preview banner
        e.target.value = ""; // Reset the file input
      };
      reader.readAsDataURL(file);
      setBannerImageFile(file); // Save file for upload
    }
  };
  // Handle file change for profile image
  const handleProfileImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileImage(reader.result); // Set the image URL as base64
        e.target.value = ""; // Reset the file input
      };
      reader.readAsDataURL(file);
      setProfileImageFile(file);
    }
  };

  const tradingId = data?.orgTradingHour?.id || 0;
  const handleSubmit = async (values, tradingHours) => {
    try {
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("tagLine", values.tagLine);
      formData.append("address1", values.address1);
      formData.append("address2", values.address2);
      // formData.append("tel", values.tel);

      formData.append("disableBotInCutsomer", values.disableBotInCutsomer);

      formData.append("contactNo", values.contactNo);
      formData.append("vatPercentage", values.vatPercentage);
      formData.append(
        "serviceChargePercentage",
        values.serviceChargePercentage
      );
      formData.append("email", values.email);
      formData.append("website", values.website);
      formData.append("aboutUs", values.aboutUs);
      formData.append("themeId", values.themeId);
      if (profileImageFile) {
        formData.append("logo", profileImageFile); // Add the profile logo file
      }
      if (bannerImageFile) {
        formData.append("banner", bannerImageFile); // Add the banner file
      }
      // Append trading hours to formData
      // tradingHours.forEach((hour, index) => {
      //   formData.append(`orgTradingHour[${index}].dayOfWeek`, hour.day_of_week);
      //   formData.append(
      //     `orgTradingHour[${index}].OpeningTime`,
      //     hour.opening_time
      //   );
      //   formData.append(
      //     `orgTradingHour[${index}].ClosingTime`,
      //     hour.closing_time
      //   );
      //   formData.append(`orgTradingHour[${index}].barTiming`, hour.bar_timing);
      //   formData.append(`orgTradingHour[${index}].id`, tradingId);
      // });

      // Append trading hours to formData
      tradingHours.forEach((hour, index) => {
        // Convert day of week from string to number (0 = Monday, 1 = Tuesday, etc.)
        const dayOfWeekMap = {
          Monday: 1,
          Tuesday: 2,
          Wednesday: 3,
          Thursday: 4,
          Friday: 5,
          Saturday: 6,
          Sunday: 0,
        };

        const dayNumber = dayOfWeekMap[hour.day_of_week] || 0;

        formData.append(`orgTradingHour[${index}].dayOfWeek`, dayNumber);
        formData.append(
          `orgTradingHour[${index}].openingTime`,
          hour.opening_time
        );
        formData.append(
          `orgTradingHour[${index}].closingTime`,
          hour.closing_time
        );
        formData.append(`orgTradingHour[${index}].barTiming`, hour.bar_timing);
        formData.append(`orgTradingHour[${index}].id`, tradingId);
      });

      const response = await axios.put(ORG_PROFILE_UPDATE(orgCode), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${user.accessToken}`,
        },
      });

      console.log("Response:", response.data);
      toast.success("Form submitted successfully!");
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Error submitting form. Please try again.");
    }
  };

  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!modalOpen);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="position-relative mx-n4 mt-n4">
            <div
              className="profile-wid-bg profile-setting-img"
              style={{ background: "none" }}
            >
              <img
                src={bannerImage || data?.displayImageBanner?.getCDNUrl()}
                className="profile-wid-img"
                alt="banner"
              />
              <div
                className="overlay-content"
                style={{ background: "transparent" }}
              >
                <div className="text-end p-3">
                  <div className="p-0 ms-auto rounded-circle profile-photo-edit">
                    <Input
                      id="profile-foreground-img-file-input"
                      type="file"
                      className="profile-foreground-img-file-input"
                      onChange={handleBannerImageChange} // Handle banner file change
                    />
                    <Label
                      htmlFor="profile-foreground-img-file-input"
                      className="profile-photo-edit btn btn-light"
                    >
                      <i className="ri-image-edit-line align-bottom me-1"></i>{" "}
                      Change Banner
                    </Label>
                  </div>
                  {/* <div className=" text-end  mb-3">
                    <button className="btn btn-success" onClick={toggleModal}>
                      Generate QR
                    </button>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <Row>
            <Col md={4} xxl={3}>
              <Card className="mt-n5">
                <CardBody className="p-4">
                  <div className="text-center">
                    <div className="profile-user position-relative d-inline-block mx-auto mb-4">
                      <img
                        src={
                          profileImage || data?.cloudR2ImagePath?.getCDNUrl()
                        }
                        className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                        alt="user-profile"
                      />
                      <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
                        <Input
                          id="profile-img-file-input"
                          type="file"
                          className="profile-img-file-input"
                          onChange={handleProfileImageChange} // Call function on change
                        />
                        <Label
                          htmlFor="profile-img-file-input"
                          className="profile-photo-edit avatar-xs"
                        >
                          <span className="avatar-title rounded-circle bg-light text-body">
                            <i className="ri-camera-fill"></i>
                          </span>
                        </Label>
                      </div>
                    </div>
                    <h5 className="mb-1">{data?.name}</h5>
                    <p className="text-muted mb-0">{data?.tagLine}</p>
                  </div>
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  <div className="d-flex align-items-center mb-4">
                    <div className="flex-grow-1">
                      <h5 className="card-title mb-0">Portfolio</h5>
                    </div>
                    <div className="flex-shrink-0">
                      <Link
                        to="#"
                        className="badge bg-light text-primary fs-12"
                      >
                        <i className="ri-add-fill align-bottom me-1"></i> Add
                      </Link>
                    </div>
                  </div>
                  <div className="mb-3 d-flex">
                    <div className="avatar-xs d-block flex-shrink-0 me-3">
                      <span className="avatar-title rounded-circle fs-16 bg-body text-body">
                        <i className="ri-github-fill"></i>
                      </span>
                    </div>
                    <Input
                      type="email"
                      className="form-control"
                      id="gitUsername"
                      placeholder="Username"
                      defaultValue="@daveadame"
                    />
                  </div>
                  <div className="mb-3 d-flex">
                    <div className="avatar-xs d-block flex-shrink-0 me-3">
                      <span className="avatar-title rounded-circle fs-16 bg-primary">
                        <i className="ri-global-fill"></i>
                      </span>
                    </div>
                    <Input
                      type="text"
                      className="form-control"
                      id="websiteInput"
                      placeholder="www.example.com"
                      defaultValue="www.velzon.com"
                    />
                  </div>
                  <div className="mb-3 d-flex">
                    <div className="avatar-xs d-block flex-shrink-0 me-3">
                      <span className="avatar-title rounded-circle fs-16 bg-success">
                        <i className="ri-dribbble-fill"></i>
                      </span>
                    </div>
                    <Input
                      type="text"
                      className="form-control"
                      id="dribbleName"
                      placeholder="Username"
                      defaultValue="@dave_adame"
                    />
                  </div>
                  <div className="d-flex">
                    <div className="avatar-xs d-block flex-shrink-0 me-3">
                      <span className="avatar-title rounded-circle fs-16 bg-danger">
                        <i className="ri-pinterest-fill"></i>
                      </span>
                    </div>
                    <Input
                      type="text"
                      className="form-control"
                      id="pinterestName"
                      placeholder="Username"
                      defaultValue="Advance Dave"
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md={8} xxl={9}>
              <Card className="mt-md-n5">
                <CardHeader>
                  <Nav
                    className="nav-tabs-custom rounded card-header-tabs border-bottom-0"
                    role="tablist"
                  >
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" })}
                        onClick={() => tabChange("1")}
                      >
                        <i className="fas fa-home"></i>
                        Personal Details
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" })}
                        onClick={() => tabChange("2")}
                      >
                        <i className="far fa-user"></i>
                        Theme
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" })}
                        onClick={() => tabChange("3")}
                      >
                        <i className="far fa-user"></i>
                        Trading Hours
                      </NavLink>
                    </NavItem>
                  </Nav>
                </CardHeader>
                <Formik
                  initialValues={initialValues}
                  enableReinitialize
                  // validationSchema={validationSchema}
                  onSubmit={async (values, { setSubmitting }) => {
                    try {
                      // Pass the form values along with orgTradingHour if needed
                      await handleSubmit(values, values.orgTradingHour);
                      setSubmitting(false);
                    } catch (error) {
                      console.error("Error submitting form:", error);
                      setSubmitting(false);
                    }
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    isSubmitting,
                    handleSubmit,
                    isValid,
                    setFieldValue,
                  }) => (
                    <Form onSubmit={handleSubmit}>
                      <CardBody className="p-4">
                        <TabContent activeTab={activeTab}>
                          <TabPane tabId="1">
                            {/* Personal Details Form */}
                            <PersonalDetail
                              values={values}
                              initialValues={initialValues}
                              errors={errors}
                              touched={touched}
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              setFieldValue={setFieldValue}
                            
                            />
                            <div className="text-end mt-3">
                              <Button
                                color="success"
                                onClick={() => {
                                  if (isValid) goToNextTab();
                                }}
                              >
                                Next
                              </Button>
                            </div>
                          </TabPane>
                          <TabPane tabId="2">
                            <UpdateTheme
                              values={values}
                              goToPreviousTab={goToPreviousTab}
                              goToNextTab={goToNextTab}
                              isValid={isValid}
                              handleChange={handleChange}
                            />
                          </TabPane>
                          <TabPane tabId="3">
                            {/* Update Trading Hours */}
                            <UpdateTradingHour
                              values={values}
                              errors={errors}
                              touched={touched}
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              setFieldValue={setFieldValue} // Passing setFieldValue to child
                              onSave={(newData) => {
                                // Handle save locally and prevent form submit
                                setFieldValue("orgTradingHour", newData);
                              }}
                              isSubmitting={isSubmitting}
                              isValid={isValid}
                              goToPreviousTab={goToPreviousTab}
                            />
                            {/* <div className="d-flex justify-content-end align-items-end text-end mt-3 gap-4">
                              <Button color="danger" onClick={goToPreviousTab}>
                                Previous
                              </Button>
                            </div> */}
                          </TabPane>
                        </TabContent>
                      </CardBody>
                    </Form>
                  )}
                  {/* console.log("🚀 ~ UpdateProfile ~ isValid:", isValid) */}
                </Formik>
              </Card>
            </Col>
          </Row>
        </Container>

        <QrModal isOpen={modalOpen} toggleModal={toggleModal} id={id} />
      </div>
    </React.Fragment>
  );
};

export default UpdateProfile;
